import { Fragment, useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { useDispatch, useSelector } from 'react-redux';

import { formatNumber, sortTableDateFecha, sortTableStatusStatus } from '../../utils/generalFunctions';

import { editarBreadcrumb } from '../../actions/breadcrumb';
import { buscarPaquetes } from '../../actions/paquetes';

import DetallesPaquete from './DetallesPaquete';

const Paquetes = () => {

    let rutasBread = [
        {
            activo: true,
            nombre: 'Paquetes',
            path: '/paquetes'
        }
    ];

    const dispatch = useDispatch();

    const { listado } = useSelector(state => state.paquetes);

    const [paquetes, setPaquetes] = useState([]);

    const [paqueteDetalles, setPaqueteDetalles] = useState(null);

    const paginationOptions = { rowsPerPageText: 'Filas por página', rangeSeparatorText: 'de' };

    const columns = [
        {
            name: 'Paquete',
            sortable: true,
            selector: row => row.paquete?.nombre || 'Sin definir',
            grow: 2
        },
        {
            name: 'Total',
            sortable: true,
            selector: row => formatNumber(row.total, 2, '$ ', '')
        },
        {
            name: 'Método de pago',
            sortable: true,
            selector: row => {
                switch(row.metodo){
                    case 0: return 'Efectivo';
                    case 1: return 'Tarjeta';
                    case 2: return 'Transferencia';
                    default: return 'Sin definir';
                }
            }
        },
        {
            name: 'Fecha de compra',
            sortable: true,
            sortFunction: sortTableDateFecha,
            cell: row => new Date(row.fecha).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' }) +
                         ' a las ' + new Date(row.fecha).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' }),
            grow: 2
        },
        {
            name: 'Citas totales',
            sortable: true,
            selector: row => formatNumber(row.citas_totales, 0, '', '')
        },
        {
            name: 'Citas disponibles',
            sortable: true,
            selector: row => formatNumber(row.citas_disponibles, 0, '', '')
        },
        {
            name: '',
            cell: row => (
                <div className="text-end w-100">
                    <button type="button" className="btn btn-sm btn-link" onClick={() => setPaqueteDetalles({ id: row._id })}><i className="fas fa-eye"></i></button>
                </div>
            )
        }
    ];

    useEffect(() => {
        dispatch(buscarPaquetes());
    }, []);

    useEffect(() => {
        setPaquetes(listado);
    }, [listado]);

    useEffect(() => {
        dispatch(editarBreadcrumb(rutasBread));
    }, [rutasBread]);

    return (
        <Fragment>
            <DetallesPaquete
                paquete={paqueteDetalles}
                reestablecerPaquete={setPaqueteDetalles}
            />

            <div className="row">
                <div className="col-md-10 offset-md-1 pb-4">
                    <h3 className="my-5">Historial de paquetes</h3>

                    <div className="mt-2">
                        <DataTable
                            columns={columns}
                            data={paquetes}
                            noDataComponent="No hay paquetes registrados"
                            pagination
                            paginationPerPage={20}
                            paginationRowsPerPageOptions={[5, 10, 20, 50]}
                            paginationComponentOptions={paginationOptions}
                            highlightOnHover={true}
                        />
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

export default Paquetes;
